<template>
    <v-container>
      <div>
        <v-row justify="space-between">
          <v-col cols="12" sm="6" justify="center">
            <p class="header-title"> {{$t('report_management.title')}} </p>
          </v-col>

          <v-col cols="12" sm="6" justify="center">
            <v-row justify="start" class="pl-10">
              <v-col cols="12" sm="3">
                
              </v-col>
              <v-col cols="12" sm="6">
                <vc-date-picker mode="range" v-model="dateRange" :popover="{label: 'Hover', visibility: 'hover'}" > 
                </vc-date-picker>
              </v-col>
              
              <v-col cols="12" sm="3">
                  <v-btn color="primary" dark @click="getData">{{ $t('common.search')}}</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <v-data-table :headers="headers" :items="desserts" :search="search" :loading="loading" class="elevation-1" hide-default-footer :page.sync="page" :items-per-page="itemsPerPage"  @page-count="pageCount = $event">
          <template v-slot:top>
              <v-toolbar flat color="white" class="pt-5">
                <v-row justify="start">
                    <v-col cols="12" sm="1">
                        <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined :dense="true"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="2">
                    </v-col>
                    
                    <v-col cols="12" sm="2">
                    </v-col>

                    <v-col cols="12" sm="7">
                        <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line hide-details outlined :dense="true"></v-text-field>
                    </v-col>
                </v-row>
                  
              </v-toolbar>
          </template>

          <!-- <template v-slot:item.action="{ item }">
              <v-icon  small class="mr-2"  @click="editItem(item)">
                  edit
              </v-icon>
              <v-icon  small @click="deleteItem(item)">
                  delete
              </v-icon>
          </template> -->
          <template v-slot:[`item.request`]="{ item }">
              <span class="text-no-wrap">{{item.request.requestTitle}}</span>
          </template>

          <template v-slot:[`item.createdAt`]="{ item }">
              <span class="text-no-wrap">{{item.createdAt | formateDate}}</span>
          </template>

          <template v-slot:[`item.reporter`]="{ item }">
              <div class="contentAddress">
              <v-avatar size="30" class="mr-1">
                <img v-if="item.reporter.avatar" :src="baseImage + item.reporter.avatar"/>
                <img v-else src='@/assets/avatar_default.png'/>
              </v-avatar>

              <span class="text-no-wrap"> {{ item.reporter.fullname }} </span> 
            </div>
          </template>

          <template v-slot:[`item.content`]="{ item }">
              <span class="text-no-wrap">{{item.content}}</span>
          </template>

          <template v-slot:[`item.targetUser`]="{ item }">
              <div class="contentAddress">
              <v-avatar size="30" class="mr-1">
                <img v-if="item.targetUser.avatar" :src="baseImage + item.targetUser.avatar"/>
                <img v-else src='@/assets/avatar_default.png'/>
              </v-avatar>

              <span class="text-no-wrap"> {{ item.targetUser.fullname }} </span> 
            </div>
          </template>

          <template v-slot:no-data>
          </template>
      </v-data-table>

      <div class="text-center pt-2">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </div>
    </v-container>
</template>

<script>
  import i18n from '@/plugins/i18n';
  import moment from 'moment';

  export default {
    data: () => ({
      baseImage: process.env.VUE_APP_BASE_IMAGE,
      baseAttach: process.env.VUE_APP_BASE_ATTACH,
      
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,

      loading: true,
      numberPage: [
        5, 10, 15, 20, 25
      ],

      dateRange: { start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() },

      search: '',
      dialog: false,
      headers: [
        { text: '#', align: 'left', sortable: false, value: 'index', },
        { text: i18n.t('report_management.request'), sortable: false, value: 'request' },
        { text: i18n.t('design_manager.date'), value: 'createdAt' },
        { text: i18n.t('report_management.report_user'), sortable: false, value: 'targetUser' },
        { text: i18n.t('report_management.send_user'), value: 'reporter' },
        { text: i18n.t('report_management.content'), sortable: false, value: 'note' },
        // { text: '', value: 'action', sortable: false }
      ],
      desserts: [],
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? i18n.t('block_management.add_block') : i18n.t('block_management.edit_block')
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    async mounted() {
      await this.getData()
    },

    methods: {
        initialize () {
        },

        async getData() {
            try {
              const from = moment(String(this.dateRange.start)).format("DD/MM/YYYY");
              const to = moment(String(this.dateRange.end)).format("DD/MM/YYYY");

              const response =  await this.$http.get(process.env.VUE_APP_GET_REPORT_CONTEXT_API + "?from=" + from + "&to=" + to);
              if(response.data && response.data.success) {
                  const contextArr = response.data.data;
                  contextArr.forEach((item, index) =>item.index = index + 1);

                  this.desserts = contextArr;
                  this.loading = false;
              } else if(response.data && !response.data.success) {
                  alert(i18n.t(response.data.message));
              } else {
                  alert(i18n.t('validate.request_error'));
              } 
            } catch(e) {
                alert(i18n.t('validate.request_error'));
            }
        }
    },
  }
</script>

<style scoped>

  .v-text-field .v-input__control .v-input__slot {
    min-height: 45px !important;
    /* display: flex !important; */
    align-items: center !important;
  }
</style>